
const debounce = ( func, wait ) => {
	let timeout = 0;
	return function() {
		const context = this; const args = arguments;
		clearTimeout( timeout );
		timeout = setTimeout( function() {
			func.apply( context, args );
		}, wait );
	};
};

const isTouchScreen = (
	'ontouchstart' in window ||
	( navigator.maxTouchPoints > 0 ) ||
	( navigator.msMaxTouchPoints > 0 )
);


const fixedHeader = ( $header ) => {
	if ( $header.length === 0 ) { return false; }
	const $headerWrap = $header.parent( '.page-header-wrap' );

	const setHeaderWrapHeight = () => {
		const headerHeight = $header.outerHeight();
		$headerWrap.height( headerHeight );
	};

	const getScrollOffset = () => {
		const width = window.innerWidth;
		if ( width < 1024 ) {
			return 80;
		} else {
			return 72;
		}
	};

	const handleScroll = () => {
		const scrollTop = $( window ).scrollTop();
		const scrollOffset = getScrollOffset();

		if ( scrollTop > scrollOffset ) {
			$header.addClass( 'page-header--fixed' );
		}

		if ( scrollTop === 0 ) {
			$header.removeClass( 'page-header--fixed' );
		}
	};

	setHeaderWrapHeight();

	$( window ).on( 'resize', debounce( setHeaderWrapHeight, 150 ) );
	$( window ).on( 'scroll', handleScroll );

	handleScroll();
};

const initDesktopMenuHover = ( $desktopMenu ) => {
	$desktopMenu.find( '.menu-item-has-children' ).on( 'mouseenter', function() {
		const $this = $( this );
		$this.addClass( 'is-hover' );
	} );
	$desktopMenu.find( '.menu-item-has-children' ).on( 'mouseleave', function() {
		const $this = $( this );
		$this.removeClass( 'is-hover' );
	} );
};

const initDesktopMenuTouch = ( $desktopMenu ) => {
	$desktopMenu.find( '.menu-item-icon' ).on( 'click', function( e ) {
		e.preventDefault();
		e.stopPropagation();
		const $menuItem = $( this ).closest( 'li.menu-item-has-children' );

		if ( $menuItem.hasClass( 'is-hover' ) ) {
			$menuItem.removeClass( 'is-hover' );
		} else {
			$desktopMenu.find( 'li.menu-item-has-children.is-hover' ).removeClass( 'is-hover' );
			$menuItem.addClass( 'is-hover' );
		}
	} );

	$( document ).on( 'click touchstart', function( e ) {
		if ( $( e.target ).closest( '.menu-item-has-children' ).length === 0 ) {
			$desktopMenu.find( 'li.menu-item-has-children.is-hover' ).removeClass( 'is-hover' );
		}
	} );
};

const initBlock = function( $block ) {
	const $header = $block;
	const $desktopMenu = $header.find( '.page-header__nav .menu' );
	const $mobileMenuBtn = $header.find( '.page-header__mobile-menu-btn' );
	const $mobileMenu = $header.find( '.mobile-menu' );
	const $mobileMenuOverlay = $header.find( '.mobile-menu-overlay' );
	const $mobileMenuBtnClose = $mobileMenu.find( '.mobile-menu__close-btn' );
	const $mobileMenuHasChildren = $mobileMenu.find( '.menu-item-has-children' );

	if ( isTouchScreen ) {
		initDesktopMenuTouch( $desktopMenu );
	} else {
		initDesktopMenuHover( $desktopMenu );
	}

	const menuOpen = () => {
		$mobileMenuBtn.addClass( 'is-active' );
		$mobileMenu.addClass( 'is-active' );
		$mobileMenuOverlay.fadeIn( 400 ).addClass( 'is-active' );
		$( 'html' ).addClass( 'scroll-off' );
		$( 'body' ).addClass( 'scroll-off' );
	};

	const menuClose = () => {
		$mobileMenuBtn.removeClass( 'is-active' );
		$mobileMenu.removeClass( 'is-active' );
		$mobileMenuOverlay.fadeOut( 300 ).removeClass( 'is-active' );
		$( 'html' ).removeClass( 'scroll-off' );
		$( 'body' ).removeClass( 'scroll-off' );
	};

	$mobileMenuBtn.on( 'click', function( e ) {
		e.preventDefault();
		const $this = $( this );
		if ( $this.hasClass( 'is-active' ) ) {
			menuClose();
		} else {
			menuOpen();
		}
	} );

	$mobileMenuOverlay.on( 'click', function( e ) {
		e.preventDefault();
		menuClose();
	} );

	$mobileMenuBtnClose.on( 'click', function( e ) {
		e.preventDefault();
		menuClose();
	} );

	$mobileMenuHasChildren.children( 'a' ).children( '.menu-item-icon' ).on( 'click', function( e ) {
		e.preventDefault();
		const $thisItem = $( this ).closest( 'li' );
		const $submenu = $thisItem.find( '.sub-menu' );
		$thisItem.toggleClass( 'is-submenu-active' );
		$submenu.slideToggle();
	} );

	$( window ).on(
		'resize',
		debounce( function() {
			const width = window.innerWidth;
			if ( width >= 1081 ) {
				menuClose();
			}
		}, 150 )
	);


	fixedHeader( $header );
};

app.loadBlock( initBlock, 'block-header', '.page-header' );

if ( module.hot ) {
	module.hot.accept();
}
